import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OnRenderedDirective } from './on-rendered.directive';

@NgModule({
  declarations: [OnRenderedDirective],
  imports: [CommonModule],
  exports: [OnRenderedDirective],
})
export class OnRenderedModule {}
